import { render } from "./DistributorOrdersList.vue?vue&type=template&id=eef15414&scoped=true"
import script from "./DistributorOrdersList.vue?vue&type=script&lang=js"
export * from "./DistributorOrdersList.vue?vue&type=script&lang=js"

import "./DistributorOrdersList.vue?vue&type=style&index=0&id=eef15414&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef15414"]])

export default __exports__